import _extends from "reshow-runtime/es/helpers/extends";
import _slicedToArray from "reshow-runtime/es/helpers/slicedToArray";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import React, { useState, useEffect, useMemo, useRef, forwardRef, useImperativeHandle } from "react";
import { Image } from "react-atomic-molecule";
import { win } from "win-doc";
import Change from "../organisms/Change";

var AnimateImageComp = function AnimateImageComp(props, ref) {
  var src = props.src,
      animate = props.animate,
      otherProps = _objectWithoutProperties(props, ["src", "animate"]);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      image = _useState2[0],
      setImage = _useState2[1];

  var oImg = useRef();
  useImperativeHandle(ref, function () {
    return {
      getImageObject: function getImageObject() {
        return oImg.current;
      }
    };
  });
  useEffect(function () {
    var oWin = win();

    if (!oWin) {
      return null;
    }

    oImg.current = new oWin.Image();

    oImg.current.onload = function () {
      setImage( /*#__PURE__*/React.createElement(Image, _extends({
        src: src
      }, otherProps)));
    };

    oImg.current.src = src;
  }, [src]);
  return useMemo(function () {
    return /*#__PURE__*/React.createElement(Change, _extends({
      className: "animate-image"
    }, animate), image);
  }, [image, animate]);
};

var AnimateImage = forwardRef(AnimateImageComp);
AnimateImage.defaultProps = {
  animate: {
    enter: "fadeIn-300",
    leave: "fadeOut-300"
  }
};
export default AnimateImage;